<template lang="pug">
b-container
  //- large screen
  b-row.justify-content-center.align-items-center.d-lg-none
    b-col.text.footer.d-flex.justify-content-center.align-items-center.mt-5(cols="12")
      div © 2020 mktBI. All Rights Reserved.
    b-col.text.footer.d-flex.justify-content-center.align-items-center.mb-5(cols="12")
      router-link(class="cursor color mr-3" :to="{ name: 'Home', query: { section: 'solutions' }}") Solutions 
      router-link(class="cursor color mr-3" :to="{ name: 'Home', query: { section: 'use-cases' }}") Use Cases
      router-link(class="cursor color mr-3" :to="{ name: 'Home', query: { section: 'benefits' }}") Benefits
      router-link(class="cursor color mr-3" :to="{ name: 'About' }") About
    b-col.col-12.d-flex.justify-content-center.mb-5
      router-link(to="/home").cursor
        img(src="../../assets/images/mktBiLogo.png")
  //- small screen
  b-row.justify-content-center.d-none.d-lg-flex.align-items-center
    b-col.text.footer.d-flex.justify-content-lg-start.align-items-center(cols="10")
      .mr-4 © 2020 mktBI. All Rights Reserved.
      .mr-4 |
      router-link(class="cursor color mr-3" :to="{ name: 'Home', query: { section: 'solutions' }}") Solutions 
      router-link(class="cursor color mr-3" :to="{ name: 'Home', query: { section: 'use-cases' }}") Use Cases
      router-link(class="cursor color mr-3" :to="{ name: 'Home', query: { section: 'benefits' }}") Benefits
      router-link(class="cursor color mr-3" :to="{ name: 'About' }") About
    b-col.col-2.d-flex.justify-content-center
      router-link(to="/home").cursor
        img(src="../../assets/images/mktBiLogo.png")

</template>

<script>
export default {
  name: 'Footer',
  methods: {
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.text{
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: #364149;
}

.cursor{
  cursor: pointer;

    
}

.color{
  color: #364149;
  text-decoration: none;
    
}

@media only screen and (min-width: 991px) {
  .footer {
    height: 284px;
  }
  img {
    float: right !important;
  }
}

</style>
